<template>
    <b-navbar toggleable="lg" type="dark" variant="primary">
        <b-navbar-brand>
            <b-button
                pressed
                variant="primary"
                @click="$emit('toggle-sidebar')"
            >
                <b-icon icon="list"></b-icon>
            </b-button>
            &nbsp;&nbsp;

            <router-link
                to="/"
                class="
                    h4
                    mb-0
                    text-lg text-white text-uppercase
                    d-none d-lg-inline-block
                "
                >OMS</router-link
            >
            <template v-for="(path, key) in paths">
                <span
                    class="
                        h4
                        mb-0
                        text-lg text-white text-uppercase
                        d-none d-lg-inline-block
                    "
                    :key="key + 'span'"
                    >&nbsp;/&nbsp;</span
                >
                <router-link
                    :to="path.path"
                    class="
                        h4
                        mb-0
                        text-lg text-white text-uppercase
                        d-none d-lg-inline-block
                    "
                    :key="key"
                    >{{ path.text | capitalize }}</router-link
                >
            </template>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> 

        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>
                    <!-- Using 'button-content' slot -->
                    <template #button-content>
                        <em>{{ user.email }}</em>
                    </template>
                    <b-dropdown-item to="/admin/profile"
                        >Profile</b-dropdown-item
                    >
                    <b-dropdown-item @click="logout()"
                        >Sign Out</b-dropdown-item
                    >
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>
<script>
import { capitalCase } from 'change-case'
export default {
    data() {
        return {
            activeNotifications: false,
            showMenu: false,
            searchQuery: '',
            paths: [],
        }
    },
    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
    },
    computed: {
        user() {
            return this.$store.state.user || {}
        },
    },

    watch: {
        $route() {
            // console.log('new path')
            this.calcPath()
        },
    },
    mounted() {
        this.calcPath()
    },

    methods: {
        calcPath() {
            // generate path
            let pathSplit = this.$route.path.split('/')
            pathSplit.splice(0, 1) // remove

            let paths = []
            let runningPath = ''
            for (let segment of pathSplit) {
                runningPath += '/' + segment

                paths.push({
                    path: runningPath,
                    text: segment,
                })
            }
            this.paths = paths
            console.log('pathSplit:', pathSplit)
        },

        toggleMenu() {
            this.showMenu = !this.showMenu
        },
        logout() {
            this.$store.dispatch('logout')
            this.$router.push('/login')
            return false
        },
    },
}
</script>

<style scoped>
.avatar-border {
    border: solid white 2px;
}

.pointer {
    cursor: pointer;
}

.admin-nav {
    padding: 4px 8px;
    border-radius: 4px;
}

.admin-nav:hover {
    background: rgba(255, 255, 255, 0.3);
}
</style>
